import { ButtonIcon, Icon } from 'scala'
import React, { useCallback, useMemo, useState } from 'react'
import styles from './embed-task.module.scss'
import { useEmbedPlayer } from '../../../hooks/tasks/use-embed-player'
import { Summary } from '../../../types'
import { ModalToggleLink } from '../../../components/modal-toggle-link'

interface EmbedTaskProps {
  taskId?: string
  isPublic?: boolean
  summary: Summary
}

export const EmbedTask: React.FC<EmbedTaskProps> = ({
  taskId,
  isPublic,
  summary
}) => {
  const [openedModal, setOpenedModal] = useState(false)
  const onDismissModal = useCallback(() => setOpenedModal(false), [])

  const {
    loading,
    isPublic: stateIsPublic,
    onTogglePublic,
    valueEmbed,
    onGenerateEmbed
  } = useEmbedPlayer({
    trackId: taskId,
    onDismissModal,
    summary
  })

  const isPublicState = useMemo(() => {
    if (stateIsPublic !== undefined) {
      return stateIsPublic
    }

    return isPublic
  }, [isPublic, stateIsPublic])

  const onOpenModal = useCallback(() => {
    setOpenedModal(true)

    if (isPublicState) {
      onGenerateEmbed()
    }
  }, [isPublicState, onGenerateEmbed])

  return (
    <div className={styles.container}>
      <ButtonIcon
        light
        onClick={onOpenModal}
        icon={<Icon name="code" width={20} height={20} />}
        title="Embed Moises player"
        className={styles.button}
      />

      <ModalToggleLink
        isOpen={openedModal}
        loading={loading}
        enabled={isPublicState || false}
        value={isPublicState ? valueEmbed : undefined}
        placeholder="<iframe src=https://audio.moises.ai>"
        showCancelButton
        labels={{
          title: 'Embed Moises Player',
          toggleLabel: 'Embed Moises Player',
          toggleDescription:
            'Copy the link below and paste it on your website to embed the Moises Player.',
          successToastDescription:
            'Go to your website and paste the link to embed the Moises Player'
        }}
        onToggle={onTogglePublic}
        onDismiss={onDismissModal}
      />
    </div>
  )
}
